import { collectTouch, mergeAuthFirstTouch } from "./marketingAttribution.js";

// Same key PR #349 uses for the stored first touch. This file stays free of
// publicAnalytics so post-auth path code cannot import that module back.
const FIRST_TOUCH_KEY = "dople_marketing_first_touch_v1";

function readStoredFirstTouch() {
  try {
    const raw = window.localStorage.getItem(FIRST_TOUCH_KEY) || "";
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

function writeStoredFirstTouch(next, previous) {
  try {
    if (JSON.stringify(next) === JSON.stringify(previous)) return;
    window.localStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(next));
  } catch {
    // The survey query still uses the merged values when storage is blocked.
  }
}

// Login and signup queries fill empty first-touch keys. Stored values stay.
export function reconcileAuthAttribution(search) {
  const observed = collectTouch({ search: String(search || ""), pathname: "" });
  const existing = readStoredFirstTouch();
  const merged = mergeAuthFirstTouch(existing, observed);
  writeStoredFirstTouch(merged, existing);
  return merged;
}
